import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-emptystage',
  templateUrl: './emptystage.component.html',
  styleUrls: ['./emptystage.component.css']
})
export class EmptystageComponent implements OnInit {

  @Input() formname: string = "";
  
  constructor() { }

  ngOnInit() {
  }

}
